import { Node } from "@tiptap/core";

const BaseListItem = Node.create({
  content: "text*",
  group: "inline",
  inline: true,
  renderHTML() {
    return ["li", 0];
  },
});

export const UnorderedListItem = BaseListItem.extend({
  name: "list_block_1",
});

export const OrderedListItem = BaseListItem.extend({
  name: "orderedList_block_1",
});
